import { render, staticRenderFns } from "./UserRegistrationRequestView.vue?vue&type=template&id=0135d037&"
import script from "./UserRegistrationRequestView.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationRequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports